import { gql } from "@/gql";

export const GET_FIREBASE_ANALYTICS = gql(`
  query GetFirebaseAnalytics(
    $salonId: ID!
    $startDate: String!
    $endDate: String!
    $comparisonStartDate: String
    $comparisonEndDate: String
  ) {
    firebaseAnalyticsReport(
      salonId: $salonId
      startDate: $startDate
      endDate: $endDate
      comparisonStartDate: $comparisonStartDate
      comparisonEndDate: $comparisonEndDate
    ) {
      dateRange {
        startDate
        endDate
      }
      engagement {
        activeUsers
        sessions
        pageViews
        avgSessionDuration
        bounceRate
      }
      comparisonEngagement {
        activeUsers
        sessions
        pageViews
        avgSessionDuration
        bounceRate
      }
    }
  }
`);

export const GET_COMPREHENSIVE_REPORT = gql(`
  query GetComprehensiveReport($salonId: ID!, $filters: ReportFiltersInput!) {
    comprehensiveReport(salonId: $salonId, filters: $filters) {
      salonId
      reportPeriodStart
      reportPeriodEnd
      generatedAt

      revenue {
        totalRevenue
        averageTransactionValue
        revenuePerCustomer
        newCustomerRevenue
        returningCustomerRevenue
        revenueGrowth
        previousPeriodRevenue
        totalBookings
        completedBookings
        cancelledBookings
        noShowBookings
        pendingBookings

        dailyBreakdown {
          date
          revenue
          totalAppointmentCount
          completedCount
          cancelledCount
          noShowCount
          pendingCount
        }

        serviceBreakdown {
          serviceId
          serviceName
          categoryName
          revenue
          revenuePercentage
          appointmentCount
          averagePrice
        }
      }

      customers {
        totalCustomers
        newCustomers
        returningCustomers
        customerRetentionRate
        averageCustomerLifetimeValue
        averageVisitFrequency
        averageDaysBetweenVisits
        inactiveCustomers
        averageCustomerTenure
        customerGrowthRate
        churnRate

        retentionData {
          period
          totalCustomers
          customersRetained
          retentionRate
        }

        dailyCustomerActivity {
          date
          newCustomers
          returningCustomers
        }

        topCustomers {
          customerId
          customerName
          totalSpent
          averageSpent
          visitCount
        }

        cohortRetention {
          cohortWeek
          cohortStartDate
          cohortSize
          weeklyRetention {
            weekNumber
            customersReturned
            retentionPercentage
          }
        }

        loyaltyDistribution {
          segment
          customerCount
          percentage
          totalRevenue
        }
      }

      operations {
        appointmentCancellationRate
        noShowRate
        averageServiceDuration
        averageBookingLeadTime

        serviceDurationDistribution {
          category
          averageDuration
          count
          percentage
        }

        bookingLeadTimeDistribution {
          category
          count
          percentage
        }

        peakHours {
          dayOfWeek
          timeSlot
          appointmentCount
          utilizationPercentage
        }

        serviceEfficiency {
          serviceId
          serviceName
          averageActualDuration
          scheduledDuration
          efficiencyRatio
          profitMargin
        }

        staffUtilization {
          workerId
          workerName
          hoursWorked
          totalAppointments
          totalRevenue
          revenuePerHour
          utilizationRate
        }
      }

      marketing {
        totalInquiries
        totalBookings
        overallConversionRate

        trafficSources {
          sourceId
          sourceName
          inquiries
          bookings
          conversionRate
          revenue
        }

        conversionFunnel {
          stage
          count
          conversionRate
        }
      }
    }
  }
`);
